// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"ModalCollectorListViewer_colorPrimary__q1rKb","disabledText":"ModalCollectorListViewer_disabledText__MB86Y"};